import { useEffect, useState } from 'react';
import styled from 'styled-components';

interface YotpoLlmSchemaProps {
  html?: string | null;
}

// Clipped rather than display:none so text extractors still read it pre-hydration.
const StyledVisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
`;

// Crawler-only review markup from Yotpo—rendered server-side, removed after mount
export const YotpoLlmSchema = ({ html }: YotpoLlmSchemaProps) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => setHasMounted(true), []);

  if (!html || hasMounted) return null;

  return <StyledVisuallyHidden dangerouslySetInnerHTML={{ __html: html }} />;
};
